import { DropdownItemReg } from './DropdownItemReg';
import { DropdownTypeEnum } from '../../enums/dropdownTypeEnum';

export class DropdownGroupReg {
    constructor(
        dropdownGroupRegId: string,
        dropdownTypeId: DropdownTypeEnum,
        eventInputDropdownGroupId: number,
        dropdownItemRegList: DropdownItemReg[]
    ) {
        this.dropdownGroupRegId = dropdownGroupRegId;
        this.dropdownTypeId = dropdownTypeId;
        this.eventInputDropdownGroupId = eventInputDropdownGroupId;
        this.dropdownItemRegList = dropdownItemRegList;
    }
    dropdownGroupRegId: string;
    dropdownTypeId: DropdownTypeEnum;
    eventInputDropdownGroupId: number;
    dropdownItemRegList: DropdownItemReg[];
}
